import { BusinessUnitService } from '../model/business-unit.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { BusinessUnit } from 'assets-model';
import { Observable } from 'rxjs';


export class BusinessUnitDataSource extends CrudDataSource<BusinessUnit> {

  constructor(private service: BusinessUnitService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<BusinessUnit>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


